export default __webpack_public_path__ + "static/media/inovacao.2f66ba29.svg";